import actionTypes from './actionTypes'
import config from '../../../config/config'
import { getToken, checkJapanese } from '../../../lib'

const {
  CHANGE_SUCCESS,
  GET_USERS_EXPIRED,
  GET_MA_EXPIRED,
  GET_ACTIVATION_EMAIL,
  MA_SIGNUP_EMAIL,
  GET_DOMAIN
} = actionTypes


export const changeSuccess = () => ({
  type: CHANGE_SUCCESS
})
export const getUsersExpiredTemplate = (data) => ({
  type: GET_USERS_EXPIRED,
  data
})
export const getMAExpiredTemplate = (data) => ({
  type: GET_MA_EXPIRED,
  data
})
export const getActivationEmailTemplate = (data) => ({
  type: GET_ACTIVATION_EMAIL,
  data
})

export const getMASignupEmailTemplate = (data) => ({
  type: MA_SIGNUP_EMAIL,
  data
})

export const getDomainList = (data) => ({
  type: GET_DOMAIN,
  data
})
export function changeTemplate(id, payload) {
  return function (dispatch) {
    dispatch(changeSuccess())
    const token = getToken();
    return fetch(`${config.URI}/api/v1/fvdomain/email_template/${id}`, {
      method: 'PUT',
      headers: {
        'Authenticity-Token': token,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    })
      .then((temp) => temp.json())
      .then(res => {
        if (res.status === 'success') {
          dispatch(changeSuccess())
        } else {
          let warning = checkJapanese() ? 'サーバーとの接続にエラーが発生しました。' : 'There was an error connecting to the server.';
          alert(warning)
        }
      })
      .catch((error) => {
        let warning = checkJapanese() ? 'サーバーとの接続にエラーが発生しました。' : 'There was an error connecting to the server.';
        alert(warning)
        console.error(error);
      });
  }
}

export function getExpiredUserDefaultTemplate(id) {
  return function (dispatch) {
    dispatch(changeSuccess())
    const token = getToken();
    return fetch(`${config.URI}/api/v1/fvdomain/email_template_get_expired_user/${id}`, {
      method: 'GET',
      headers: {
        'Authenticity-Token': token,
        'Content-Type': 'application/json'
      },
    })
      .then((temp) => temp.json())
      .then(res => {
        if (res.status === 'success') {
          dispatch(getUsersExpiredTemplate({ data: res.data }))
        } else {
          let warning = checkJapanese() ? 'サーバーとの接続にエラーが発生しました。' : 'There was an error connecting to the server.';
          alert(warning)
        }
      })
      .catch(() => {
        let warning = checkJapanese() ? 'サーバーとの接続にエラーが発生しました。' : 'There was an error connecting to the server.';
        alert(warning)
      });
  }
}
export function expiredMADefault(id) {
  return function (dispatch) {
    dispatch(changeSuccess())
    const token = getToken();
    return fetch(`${config.URI}/api/v1/fvdomain/email_template_get_expired_ma/${id}`, {
      method: 'GET',
      headers: {
        'Authenticity-Token': token,
        'Content-Type': 'application/json'
      },
    })
      .then((temp) => temp.json())
      .then(res => {
        if (res.status === 'success') {
          dispatch(getMAExpiredTemplate({ data: res.data }))
        } else {
          let warning = checkJapanese() ? 'サーバーとの接続にエラーが発生しました。' : 'There was an error connecting to the server.';
          alert(warning)
        }
      })
      .catch(() => {
        let warning = checkJapanese() ? 'サーバーとの接続にエラーが発生しました。' : 'There was an error connecting to the server.';
        alert(warning)
      });
  }
}

export function editActivationEmailTemplate(id) {
  return function (dispatch) {
    dispatch(changeSuccess())
    const token = getToken();
    return fetch(`${config.URI}/api/v1/fvdomain/email_template/${id}`, {
      method: 'GET',
      headers: {
        'Authenticity-Token': token,
        'Content-Type': 'application/json'
      },
    })
      .then((temp) => temp.json())
      .then(res => {
        if (res.status === 'success') {
          dispatch(getActivationEmailTemplate({ data: res.data }))
        } else {
          let warning = checkJapanese() ? 'サーバーとの接続にエラーが発生しました。' : 'There was an error connecting to the server.';
          alert(warning)
        }
      })
      .catch((error) => {
        let warning = checkJapanese() ? 'サーバーとの接続にエラーが発生しました。' : 'There was an error connecting to the server.';
        alert(warning)
        console.error(error);
      });
  }
}

export function MASignupEmailTemplate(id) {
  return function (dispatch) {
    dispatch(changeSuccess())
    const token = getToken();
    return fetch(`${config.URI}/api/v1/fvdomain/email_template_get_signup_ma/${id}`, {
      method: 'GET',
      headers: {
        'Authenticity-Token': token,
        'Content-Type': 'application/json'
      },
    })
      .then((temp) => temp.json())
      .then(res => {
        if (res.status === 'success') {
          dispatch(getMASignupEmailTemplate({ data: res.data }))
        } else {
          let warning = checkJapanese() ? 'サーバーとの接続にエラーが発生しました。' : 'There was an error connecting to the server.';
          alert(warning)
        }
      })
      .catch((error) => {
        let warning = checkJapanese() ? 'サーバーとの接続にエラーが発生しました。' : 'There was an error connecting to the server.';
        alert(warning)
        console.error(error);
      });
  }
}

export function getSingleDomainData(id) {
  return function (dispatch) {
    return fetch(`${config.URI}/api/v1/fvdomains/${id}`, {
      method: 'GET',
      headers: {
        'Authenticity-Token': getToken(),
        'Content-Type': 'application/json'
      }
    })
      .then((temp) => temp.json())
      .then(res => {
        if (res.status === 'success') {
          dispatch(getDomainList({ data: res }))
        }
      })
      .catch((error) => {
        console.log(error)
      })
  }
}




// WEBPACK FOOTER //
// src/routes/Domain/actions/index.js